import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class EntityRefOfString
*  Информация о связанных данных
*/
export class EntityRefOfString extends ActiveModel {

/**
  * id
  * Идентификатор связанных данных<br>
  */
  @ActiveField('')
  id: string = ''


/**
  * displayName
  * Название связанных данных<br>
  */
  @ActiveField()
  displayName?: null | string
}
